import type { QuiltWrapperFragment } from '@aurora/shared-generated/types/graphql-types';
import React from 'react';

export default React.createContext<QuiltWrapperFragment | null>(null);
